import React, {useState, useEffect} from 'react';
import Select from 'ROOT/src/components/formElements/Select';
import sAction from 'sAction';
import PropTypes from 'prop-types';
import RequestAccessSent from './RequestAccessSent';

function RequestAccess(props) {
    const keyPre = 'RequestAccess_';
    const countryOptions = createOptions(sAction.app_strings['countries_dom']);
    const regionOptions = createOptions(sAction.app_strings['region_list']);
    const requiredFields = ['name', 'surname', 'email', 'company', 'country', 'region'];

    const [state, setState] = useState({
        name: null,
        surname: null,
        country: null,
        company: null,
        email: null,
        region: null,
        message: null,
    });

    const [error, setError] = useState({
        error: false,
        message: '',
        missingFields: [],
    });

    const [showSuccess, setShowSuccess] = useState(false);

    useEffect(() => {
        if (error.error) {
            checkRequiredFields();
        }
    }, [state]);


    const submitForm = () => {
        if (checkRequiredFields()) {
            requestAccess(state);
        }
    };

    const checkRequiredFields = () => {
        const missingFields = [];
        requiredFields.forEach((field) => {
            if (!state[field]) {
                missingFields.push(field);
            }
        });
        if (missingFields.length > 0) {
            setError({
                error: true,
                message: `Please fill in the following fields: ${missingFields.join(', ')}`,
                missingFields,
            });
            return false;
        } else {
            setError({
                error: false,
                message: '',
                missingFields: [],
            });
            return true;
        }
    };

    const requestAccess = (data) => {
        console.log('>> requestAccess', data);
        sAction.load();

        // TODO: send data to server and create a request in module 'Access Requests'
        const requestData = {
            first_name: state.name,
            last_name: state.surname,
            account: state.company,
            email: state.email,
            region: state.region,
            country: state.country,
            description: state.message,
        };

        sAction.rest.fetchData('requestAccess', 'POST', {form: requestData}).then((returnData) => {
            sAction.unLoad();
            setShowSuccess(true);
        });
    };

    if (showSuccess) {
        return (<RequestAccessSent />);
    }

    return (
        <div
            className="loginBoxContainer requestAccess"
            onKeyDown={(e) => onKeyDown(e)}
        >
            <div className="loginPageContentForm">
                <div className="loginPageContentFormContainer">
                    <div className="loginPageContentFormContainerTitle">
                        <h2>{sAction.translate('LBL_REQUEST_NEW_ACCOUNT', 'aon_portal_access_requests')}</h2>
                    </div>
                    <div className="requestAccessForm">
                        <div className={'requestAccessFormInput required' + (error.missingFields.includes('name') ? ' empty' : '')}>
                            <label htmlFor="name">{sAction.translate('LBL_NAME', 'aon_portal_access_requests')}</label>
                            <input className="formInput" type="text" id="name"
                                onChange={(e) => setState({...state, name: e.target.value})}/>
                        </div>
                        <div className={'requestAccessFormInput required' + (error.missingFields.includes('surname') ? ' empty' : '')}>
                            <label htmlFor="surname">{sAction.translate('LBL_SURNAME', 'aon_portal_access_requests')}</label>
                            <input className="formInput" type="text" id="surname"
                                onChange={(e) => setState({...state, surname: e.target.value})}/>
                        </div>
                        <div className={'requestAccessFormInput required' + (error.missingFields.includes('email') ? ' empty' : '')}>
                            <label htmlFor="email">{sAction.translate('LBL_EMAIL_ADDRESS', 'aon_portal_access_requests')}</label>
                            <input className="formInput" type="text" id="email"
                                onChange={(e) => setState({...state, email: e.target.value})}/>
                        </div>
                        <div className={'requestAccessFormInput required' + (error.missingFields.includes('company') ? ' empty' : '')}>
                            <label htmlFor="company">{sAction.translate('LBL_COMPANY', 'aon_portal_access_requests')}</label>
                            <input className="formInput" type="text" id="company"
                                onChange={(e) => setState({...state, company: e.target.value})}/>
                        </div>
                        <div className={'requestAccessFormInput required' + (error.missingFields.includes('country') ? ' empty' : '')}>
                            <label htmlFor="country">{sAction.translate('LBL_COUNTRY', 'aon_portal_access_requests')}</label>
                            <Select
                                open={false}
                                name={keyPre + '_country'}
                                id="country"
                                options={countryOptions}
                                defaultValue={state.country}
                                disabled={false}
                                key={keyPre + '_country'}
                                onChange={(ev) => {
                                    console.log('val changed ', ev.target.value);
                                    setState({
                                        ...state,
                                        country: ev.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className={'requestAccessFormInput required' + (error.missingFields.includes('region') ? ' empty' : '')}>
                            <label htmlFor="region">{sAction.translate('LBL_REGION', 'aon_portal_access_requests')}</label>
                            <Select
                                open={false}
                                name={keyPre + '_region'}
                                id="region"
                                options={regionOptions}
                                defaultValue={state.region}
                                disabled={false}
                                key={keyPre + '_region'}
                                onChange={(ev) => {
                                    console.log('val changed ', ev.target.value);
                                    setState({
                                        ...state,
                                        region: ev.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="requestAccessFormInput">
                            <label htmlFor="message">{sAction.translate('LBL_MESSAGE', 'aon_portal_access_requests')}</label>
                            <textarea
                                className="formInput formInputTextarea"
                                id="message"
                                onChange={(e) => setState({...state, message: e.target.value})}
                            />
                        </div>
                    </div>
                    <div className="requestAccessFormSubmit">
                        <button type="submit" className="button full signInBtn" onClick={submitForm}>
                            {sAction.translate('LBL_SUBMIT', 'aon_portal_access_requests')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function createOptions(optionsSource) {
    const options = [];
    optionsSource.forEachObject((value, key) => {
        const line = {
            label: value,
            value: key,
        };
        options.push(line);
    });
    return options;
}

function onKeyDown(e) {

}

export default RequestAccess;

RequestAccess.propTypes = {
    goToLogin: PropTypes.function,
};
